(function() {
    var swiper = new Swiper('.logo-carousel .swiper', {
        spaceBetween: 24,
        slidesPerView: 2,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            enabled: false,
            nextEl: '.swiper-arrow--next',
            prevEl: '.swiper-arrow--prev',
        },
        pagination: {
            enabled: true,
            el: '.swiper-pagination',
        },
        breakpoints: {
            475: {
                slidesPerView: 3,
                navigation: {
                    enabled: false,
                },
                pagination: {
                    enabled: true,
                }
            },
            640: {
                slidesPerView: 4,
                navigation: {
                    enabled: false,
                },
                pagination: {
                    enabled: true
                }
            },
            1024: {
                slidesPerView: 6,
                navigation: {
                    enabled: true,
                },
                pagination: {
                    enabled: false
                }
            },
        },
    });
})();
